"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyRpConfiguration = void 0;
const getEmptyRpConfiguration = () => {
    return {
        __type: "ReviewPageConfiguration",
        version: 1,
        header: {
            videoUrl: "",
            videoName: ""
        },
        main: {
            playerConfiguration: {
                posterImage: {
                    url: "",
                    platformId: ""
                },
                analyticsToken: "",
                showLogo: true,
                playButtonColor: "black",
                addTranscriptButton: true,
                lockPlayerBar: true,
                ccOnByDefault: true,
                largeCenterPlayIcon: false,
                rectangleCenterPlayIcon: false,
                logoOverlay: {
                    url: "",
                    platformId: "",
                    displayLogo: false
                },
                aspectRatio: "horizontal"
            }
        }
    };
};
exports.getEmptyRpConfiguration = getEmptyRpConfiguration;
//# sourceMappingURL=emptyConfiguration.js.map